import { formatUsd } from "../../config/trading";
import { TableHeader } from "./TableHeader";

const ASSET_EARNINGS_COLUMNS = ["Asset", "Source", "Value", "Earnings"];
const ACCOUNT_EARNINGS_COLUMNS = ["Account", "Type", "Value", "Earnings"];

function BreakdownRow({ label, source, value, change, testId }) {
  return (
    <div className="earnings-breakdown-row" data-testid={testId}>
      <span>{label}</span>
      <em>{source}</em>
      <strong className="mono">{formatUsd(value)}</strong>
      <b className={change >= 0 ? "positive mono" : "negative mono"}>{formatUsd(change)}</b>
    </div>
  );
}

export function EarningsBreakdowns({ summary }) {
  return (
    <div className="earnings-breakdown-grid">
      <div data-testid="asset-earnings-breakdown">
        <div className="asset-subhead">ASSET EARNINGS</div>
        <div className="table-like">
          <TableHeader variant="earnings" testId="asset-earnings-table-header" columns={ASSET_EARNINGS_COLUMNS} />
          {summary.asset_breakdown.map((item) => (
            <BreakdownRow key={`${item.source}-${item.asset}`} testId={`asset-earning-${item.source}-${item.asset.toLowerCase()}-row`} label={item.asset} source={item.source.replace("okx_", "OKX ").toUpperCase()} value={item.value_usdt} change={item.current_earnings} />
          ))}
        </div>
      </div>
      <div data-testid="account-earnings-breakdown">
        <div className="asset-subhead">TRADING / FUNDING</div>
        <div className="table-like">
          <TableHeader variant="earnings" testId="account-earnings-table-header" columns={ACCOUNT_EARNINGS_COLUMNS} />
          {summary.account_breakdown.map((item) => (
            <BreakdownRow key={item.account_type} testId={`account-earning-${item.account_type}-row`} label={item.account_type.replace("okx_", "OKX ").toUpperCase()} source="ACCOUNT" value={item.value_usdt} change={item.current_earnings} />
          ))}
        </div>
      </div>
    </div>
  );
}